import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getDevice, IDeviceTypes } from '@utils/getDevice';
import { getViewport, IViewport } from '@utils/getViewport';

const mobileSlice = createSlice({
  name: 'mobileStore',
  initialState: {
    deviceType: getDevice(),
    /** Ref:
     *  * https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
     *  * https://web.dev/viewport-units/
     *  */
    viewport: getViewport(),
  },

  reducers: {
    setDevice: (state, action: PayloadAction<IDeviceTypes>) => {
      state.deviceType = action.payload;
    },
    setViewport: (state, action: PayloadAction<IViewport>) => {
      state.viewport = action.payload;
    },
  },
});
export const { setDevice, setViewport } = mobileSlice.actions;

export const { reducer: mobileReducer } = mobileSlice;
